import React, { useState } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Collapse from '@mui/material/Collapse';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { KnzComponentProps } from '../../types';

/**
 * 開閉式ワンポイント補足（WorkflowTipBox ベース）。
 * params: title（必須）、text（joined）、open（任意, "true" で初期展開）
 */
export const Tip: React.FC<KnzComponentProps> = ({ node, renderInline }) => {
  const title = (node.params.title as string) ?? 'ヒント';
  const text = (node.params.text as string) ?? '';
  const defaultOpen = (node.params.open as string) === 'true';
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 2, overflow: 'hidden' }}>
      <ButtonBase
        onClick={() => setOpen((v) => !v)}
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2,
          py: 1.5,
          textAlign: 'left',
          bgcolor: 'action.hover',
          transition: 'background-color 0.15s',
          '&:hover': { bgcolor: 'action.selected' },
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <TipsAndUpdatesIcon sx={{ fontSize: 18, color: 'warning.main' }} />
          <Typography variant="body2" fontWeight={600}>
            {title}
          </Typography>
        </Stack>
        <ExpandMoreIcon
          sx={{
            fontSize: 18,
            color: 'text.secondary',
            transition: 'transform 0.2s',
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
        />
      </ButtonBase>
      <Collapse in={open}>
        <Box sx={{ px: 2, pb: 2, pt: 1.5 }}>
          <Typography
            variant="body2"
            color="text.secondary"
            component="div"
            sx={{ lineHeight: 1.7 }}
          >
            {renderInline(text)}
          </Typography>
        </Box>
      </Collapse>
    </Box>
  );
};

export default Tip;
